module.exports = __webpack_public_path__ + "img/order-wallet-icon-black.156b6dcc.svg";